<template>
  <div>
    <div class="attachments">
      <ul>
        <li
            v-for="(attachment, index) in attachments"
            v-bind:key="attachment._id"
        >
          <template>
            <img
                width="32"
                height="32"
                v-if="attachment.type.startsWith('image')"
                :src="attachment.downloadURL+'?meeting_token='+token"
                alt=""
            />
            <div
                v-else
                :style="{
                width: '32px',
                height: '32px',
                display: 'inline-block',
                background: 'black',
              }"
            />
          </template>

          <button
              v-on:click="() => deleteAttachment(index)"
              class="remove hover_op"
          ></button>
        </li>
      </ul>
    </div>

    <div class="send_wrap">
      <button v-on:click="() => sendMessage()" class="sand hover_op">
        <img src="@/assets/img/send_icon.svg" alt=""/>
      </button>

      <MessageInputField
          v-model="messageInput"
          v-bind:suggestions="participants"
          v-on:send="sendMessage"
      />

      <label for="file" class="hover_op">
        <img src="@/assets/img/attachment_icon.svg" alt=""/>
        <input v-on:change="uploadAttachments" multiple type="file" id="file"/>
      </label>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import MessageInputField from "@/components/chat/MessageInputField";

export default {
  name: "MessageInput",
  components: {MessageInputField},

  data() {
    return {
      messageInput: {
        htmlValue: "",
        textValue: "",
        mentions: [],
      },
      attachments: [],
    };
  },

  computed: {
    token() {
      return this.$store.state.meeting.meeting.token.value;
    },

    localParticipant() {
      return this.$store.getters.localParticipant;
    },

    participants() {
      return this.$store.state.meeting.participants;
    },
    meetingId() {
      return this.$store.state.meeting.meeting.id
    }
  },

  methods: {
    async deleteAttachment(index) {
      try {
        const attachment = this.attachments[index];
        await Axios.delete(
            `${process.env.VUE_APP_BACKEND_API_URL}/meetings/${this.meetingId}/attachments/${attachment.id}`,
            {
              headers: {
                "x-meeting-token": this.token,
              },
            }
        );

        const newAttachments = [...this.attachments];
        newAttachments.splice(index, 1);

        this.attachments = newAttachments;
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      }
    },

    async uploadAttachments(event) {
      try {
        const files = event.target.files;

        const formData = new FormData();

        for (let file of files) {
          formData.append("files", file);
        }
        console.log(this.token)
        console.log("room;", this.meetingId);

        const response = await Axios.post(
            `${process.env.VUE_APP_BACKEND_API_URL}/meetings/${this.meetingId}/attachments/`,
            formData,
            {
              headers: {
                "x-meeting-token": this.token
              }
            }).then((response) => response.data)

        console.log(response)

        this.attachments = [
          ...this.attachments,
          ...response];

        event.target.value = "";
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      }
    },

    async sendMessage() {
      try {
        const {textValue, htmlValue, mentions} = this.messageInput;
        const attachments = this.attachments;

        if (attachments.length === 0 && !textValue) return;

        const payload = {
          text: textValue || "",
          html: htmlValue,
          attachments,
          mentions: [],
        };

        console.log(payload)

        await this.$store.dispatch("sendMessage", payload);

        this.messageInput = {
          htmlValue: "",
          textValue: "",
          mentions: "",
        };

        this.attachments = [];
      } catch (e) {
        this.$store.dispatch("onError", e);
        console.error(e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.send_wrap {
  padding-top: 16px;
  display: flex;
  align-items: center;
}

.mentions_wrap {
  bottom: 75%;
  position: absolute;
  padding: 32px;
  border-radius: 16px;
  background-color: #fff;
  box-shadow: 0 0 32px rgba(0, 0, 0, 0.16);

  color: #000;
  font-family: "Nunito Sans", sans-serif;
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
}

input[type="file"] {
  display: none;
}

label,
.sand {
  flex: none;
  width: 48px;
  height: 48px;
  border-radius: 16px;
  background-color: #fc5a12;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 40px;
    height: 40px;
  }
}

label {
  width: auto;
  background-color: transparent;

  img {
    width: 30px;
    height: 40px;
  }
}

.attachments {
  display: block;
  background-color: #fff;

  ul {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }

  li {
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    border-radius: 16px;
    background-color: #f9f4ef;

    img,
    div {
      width: 24px;
      height: 24px;
      border-radius: 6px;
    }

    span {
      flex: 1 1 auto;
      overflow: hidden;
      padding-right: 10px;
      text-overflow: ellipsis;
    }
  }
}

.remove {
  top: -12px;
  right: -12px;
  position: absolute;
  flex: none;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  background: #fc5a12 url("../../assets/img/close_white.svg") no-repeat center /
    12px;
}
</style>
